import lunchImage from "../images/menu-pics/lu.png";
import breakfastImage from "../images/menu-pics/bf.png";
import coffeeImage from "../images/menu-pics/co.png";
import cakeImage from "../images/menu-pics/ca.png";

// Breakfast menu data
const breakfastMenuData = [
  {
    img: breakfastImage,
    price: " 75.00 | 40.00",
    name: "Chechebsa",
    description:
      "Fresh flat bread made from Teff or Wheat, broken into small pieces whith spiced butter and red pepper",
  },
  {
    img: breakfastImage,
    price: "95.00",
    name: "Akkoo Chechebsa",
    description:
      "Fresh flat bread made from Teff or Wheat, broken into small pieces whith spiced butter and red pepper",
  },
  {
    img: breakfastImage,
    price: "145.00",
    name: "Dulet",
    description: "Stomach, liver, onion, garlic and butter",
  },
  {
    img: breakfastImage,
    price: "205.00",
    name: "Fish Dulet",
    description: "Fish, onion, garlic with Injera",
  },
  {
    img: breakfastImage,
    price: "120.00 | 70.00",
    name: "Fasting Firfir",
    description:
      "Fresh Injera soaked in red pepper sauce prepared with onion and garlic",
  },
  {
    img: breakfastImage,
    price: "140.00 | 90.00",
    name: "Firfir Bekibe Key",
    description:
      "Fresh Injera soaked in red pepper sauce prepared with onion and garlic and butter",
  },
  {
    img: breakfastImage,
    price: "65.00",
    name: "Scrambled Eggs",
    description: "Scrambled egg with onion, oil and tomato",
  },
  {
    img: breakfastImage,
    price: "80.00",
    name: "Egg Sandwich",
    description: "Fried egg with onion, oil, mayonnaise, ketchup tomato",
  },
  {
    img: breakfastImage,
    price: "90.00",
    name: "Omelet",
    description: "Egg with onion, oil and tomato",
  },
  {
    img: breakfastImage,
    price: "140.00 | 90.00",
    name: "Firfir Bekibe Allecha",
    description:
      "Fresh Injera soaked in red pepper sauce prepared with onion and garlic and butter",
  },
  {
    img: breakfastImage,
    price: "170.00 | 110.00",
    name: "Dirkosh Firfir Key",
    description:
      "Dried Injera soaked in red pepper sauce prepared with onion and garlic",
  },
  {
    img: breakfastImage,
    price: "210.00 | 130.00",
    name: "Dirkosh Firfir Bekibe Key",
    description:
      "Dried Injera soaked in red pepper sauce prepared with onion, garlic and butter",
  },
  {
    img: breakfastImage,
    price: "210.000",
    name: "Akkoo Breakfast",
    description:
      "Beaf sauce prepared with pepper, onion, garlic touch of rosmery, scrambled egg with onion, oil, tomato, fresh flat bread made from Teff or Wheat with oil",
  },
  {
    img: breakfastImage,
    price: "135.00",
    name: "Tuna Sandwich",
    description: "Tuna sauce prepared with tomato, onion and green chilly",
  },
  {
    img: breakfastImage,
    price: "70.00",
    name: "Ful",
    description: "Legume, oil, onion, tomato, berbere, green chilly and salt",
  },
  {
    img: breakfastImage,
    price: "110.00",
    name: "Akkoo Ful",
    description:
      "Legume, oil, onion, tomato, berbere, green chilly, egg and salt",
  },
  {
    img: breakfastImage,
    price: "75.00 | 45.00",
    name: "Qinche",
    description: "Qinche, oil and butter",
  },
  {
    img: breakfastImage,
    price: "20.00",
    name: "Akkoo Buna Kurs",
    description: "Barley flour and butter",
  },
];

// Lunch Data
const lunchtMenuData = [
  {
    img: lunchImage,
    price: " 260.00",
    name: "Chikina Tibs / Sauted Beef",
    description:
      "Beef tenderloin fillet cooked with onion, spiced butter, pepper and touch of rosemary",
  },
  {
    img: lunchImage,
    price: "295.00",
    name: "Doro Wat",
    description: "Chiken, onion sauce with pepper and boiled egg",
  },
  {
    img: lunchImage,
    price: "190.00",
    name: "Beef Tongue Tibs",
    description: "Beef tongue sauted with onion, garlic and touch of rosemary",
  },
  {
    img: lunchImage,
    price: "190.00 | 110.00",
    name: "Tibs Firfir Keye",
    description:
      "Beef sauce prepared with pepper, onion, garlic and a touch of rosemary",
  },
  {
    img: lunchImage,
    price: "190.00 | 110.00",
    name: "Tibs Firfir Allecha",
    description:
      "Beef sauce prepared with onion, garlic and tomato mixed with pieces of injera",
  },
  {
    img: lunchImage,
    price: "240.00 | 130.00",
    name: "Dirkosh Firfir with Beef",
    description:
      "Beef sauce prepared with pepper, onion, garlic and touch of rosemary mixed with dried injera",
  },
  {
    img: lunchImage,
    price: "235.00",
    name: "Fish Gulash",
    description: "Fish, onion, garlic, tomato and hot chilly",
  },
  {
    img: lunchImage,
    price: "195.00",
    name: "Fish Lebleb",
    description: "Fish, onion, garlic, tomato and hot chilly",
  },
  {
    img: lunchImage,
    price: "75.00 | 40.00",
    name: "Yesuf Fetfet",
    description:
      "Fresh injera soaked in sunflower seed juice seasoned with black pepper, garlic, oil and onion",
  },
  {
    img: lunchImage,
    price: "120.00 | 70.00",
    name: "Tegabino",
    description:
      "Seasoned milled chikpeas, shiro simmered in red pepper, onion and garlic",
  },
  {
    img: lunchImage,
    price: "140.00 | 80.00",
    name: "Tegabino with butter",
    description:
      "Seasoned milled chikpeas, shiro simmered in, butter, onion and garlic",
  },
  {
    img: lunchImage,
    price: "245.00",
    name: "Kikil",
    description:
      "Lamb meat simmered with onion, garlic, spiced butter touch of rosemary",
  },
  {
    img: lunchImage,
    price: "395.00",
    name: "Akkoo Non Fasting",
    description:
      "Gomen besiga, tibs firfir bekey, beallecha, shiro, chikina tibs, suf fitfit with injera",
  },
  {
    img: lunchImage,
    price: "175.00",
    name: "Akkoo Shiro Tegabino",
    description:
      "Special seasoned milled chickpeas, shiro, simmered in red pepper, onion and garlic",
  },
  {
    img: lunchImage,
    price: "190.00",
    name: "Bozena Shiro",
    description:
      "Seasoned milled chickpeas, shiro, simmered in red pepper, onion and garlic with meat",
  },
  {
    img: lunchImage,
    price: "265.00",
    name: "Akkoo Fasting / Bale 6",
    description:
      "Seasoned milled sunflower, haricot bean, flux, peanut butter, soya bean simmered in onion, green chilly and garlic with injera",
  },
  {
    img: lunchImage,
    price: "195.00",
    name: "Akkoo Fasting / Bale 3",
    description:
      "Chickpea, onion, pepper, seasoned milled sunflower, gomen with injera",
  },
  {
    img: lunchImage,
    price: "190.00 | 100.00",
    name: "Misir Kik",
    description: "Lentil sauce prepared with pepper, onion, garlic and tomato",
  },
  {
    img: lunchImage,
    price: "210.00 | 110.00",
    name: "Misir Kik with Butter",
    description:
      "Lentil sauce prepared with pepper, onion, garlic, tomato and butter",
  },
  {
    img: lunchImage,
    price: "140.00 | 80.00",
    name: "Salad",
    description: "Salad oil, onion, zucchini, mustard, tomato and green chilly",
  },
  {
    img: lunchImage,
    price: "120.00 | 70.00",
    name: "Timatim Lebleb",
    description:
      "Tomato with onion, garlic, black pepper, green and hot chilly",
  },
  {
    img: lunchImage,
    price: "195.00",
    name: "Gomen Besiga",
    description: "Gomen with meat, onion, oil, bone and butter",
  },
  {
    img: lunchImage,
    price: "160.00 | 90.00",
    name: "Soya Pea",
    description: "Soya with onion, oil and turmeric",
  },
  {
    img: lunchImage,
    price: "170.00 | 95.00",
    name: "Lin Seed Fitfit",
    description: "Lin with onion, oil and pepper",
  },
];

// Cake Data
const cakeMenuData = [
  {
    img: cakeImage,
    price: "28.00",
    name: "Banana Bread",
    description: "",
  },
  {
    img: cakeImage,
    price: "34.00",
    name: "Brownies",
    description: "",
  },
  {
    img: cakeImage,
    price: "31.00",
    name: "Fasting Chocolate",
    description: "",
  },
  {
    img: cakeImage,
    price: "28.00",
    name: "Danishes",
    description: "",
  },
  {
    img: cakeImage,
    price: "28.00",
    name: "Cinnamon Buns",
    description: "",
  },
  {
    img: cakeImage,
    price: "28.00",
    name: "Cream Puffs / Boxzano",
    description: "",
  },
  {
    img: cakeImage,
    price: "28.00",
    name: "English Cake",
    description: "",
  },
  {
    img: cakeImage,
    price: "34.00",
    name: "Cup Cake",
    description: "",
  },
  {
    img: cakeImage,
    price: "Cookies (1kg)",
    name: "230.00",
    description: "",
  },
  {
    img: cakeImage,
    price: "690.00",
    name: "Special Torte Cake (1kg)",
    description: "",
  },
  {
    img: cakeImage,
    price: "330.00",
    name: "Normal Torte Cake (1kg)",
    description: "",
  },
];

// Drinks Data
const drinksMenuData = [
  {
    img: coffeeImage,
    price: "14.00",
    name: "Tea",
    description: "",
  },
  {
    img: coffeeImage,
    price: "25.00",
    name: "Milk",
    description: "",
  },
  {
    img: coffeeImage,
    price: "26.00",
    name: "Cafe Latte",
    description: "",
  },
  {
    img: coffeeImage,
    price: "16.00",
    name: "Coffee",
    description: "",
  },
  {
    img: coffeeImage,
    price: "18.00",
    name: "Espresso",
    description: "",
  },
  {
    img: coffeeImage,
    price: "16.00",
    name: "Macchiato",
    description: "",
  },
  {
    img: coffeeImage,
    price: "16.00",
    name: "Ristretto",
    description: "",
  },
  {
    img: coffeeImage,
    price: "18.00",
    name: "Tea and Coffee Mix",
    description: "",
  },
  {
    img: coffeeImage,
    price: "30",
    name: "Cappuccino",
    description: "",
  },
  {
    img: coffeeImage,
    price: "20.00",
    name: "Fasting Macchiato",
    description: "",
  },
  {
    img: coffeeImage,
    price: "18.00",
    name: "Ginger Tea",
    description: "",
  },
  {
    img: coffeeImage,
    price: "18.00",
    name: "American Coffee",
    description: "",
  },
  {
    img: coffeeImage,
    price: "30.00",
    name: "Special Tea",
    description: "",
  },
  {
    img: coffeeImage,
    price: "32",
    name: "Double Macchiato",
    description: "",
  },
  {
    img: coffeeImage,
    price: "20.00",
    name: "Soft Drinks",
    description: "",
  },
  {
    img: coffeeImage,
    price: "16.00",
    name: "Ambo Water",
    description: "",
  },
  {
    img: coffeeImage,
    price: "23.00",
    name: "Water (1L)",
    description: "",
  },
  {
    img: coffeeImage,
    price: "16.00",
    name: "Water (1/2L)",
    description: "",
  },
];
// Special Data
const specialMenuData = [
  {
    img: lunchImage,
    price: "Call for Price",
    name: "Full Doro Wat",
    description: "",
  },
  {
    img: lunchImage,
    price: "Call for Price",
    name: "Fastin and Non Fasting Agelgil",
    description: "",
  },
];

export {
  breakfastMenuData,
  lunchtMenuData,
  cakeMenuData,
  drinksMenuData,
  specialMenuData,
};
